<template>
<v-container id="main">
    <v-row>
      <v-col align="center">
        <h1 v-if="$router.currentRoute.fullPath == '/driver'"
            class="info--text headers1" 
            style="text-align: center; margin-bottom: 2cm; margin-top: 1cm;"> Become a Service Provider </h1>
      </v-col>
    </v-row>
    <v-row id="step" justify="center">
    <v-col align="center">
    <v-chip large color="info main--text" class="px-6"> <span class="steps"> 1 </span> </v-chip>
    <br/> <br/>
    <v-divider class="line-divider"></v-divider> <v-divider class="line-divider"></v-divider>
    <br/>
    <v-row justify="center">
      <h2 class="primary--text"> Sign up </h2>
    </v-row>
    <v-row justify="center">
      <v-img 
      src="@/assets/Sign up.svg" 
      alt="Imange1"  
      max-height="170"
      max-width="170"
      class="pt-10 mt-4"
      contain
      />
    </v-row>
    <v-row justify="center">
    <v-col align="center">
      <p class="info--text pl-4"> Click <a style="padding: 0px 5px 0px 5px; color: #4BB27C; font-size: 18px;" href="https://app.wrappwaste.com/driver-signup">here</a> and Sign up. Provide us with your details. </p>
    </v-col>
    </v-row>
    </v-col>
    <v-col align="center">
    <v-chip large color="info main--text" class="px-6"> <span class="steps"> 2 </span> </v-chip>
    <br/> <br/>
    <v-divider class="line-divider"></v-divider><v-divider class="line-divider"></v-divider>
    <br/>
    <v-row justify="center">
      <h2 class="primary--text"> Meet us </h2>
    </v-row>
    <v-row justify="center">
      <v-img 
      src="@/assets/Meet.svg" 
      alt="Imange1"  
      max-height="170"
      max-width="170"
      class="pt-10 mt-4"
      contain
      />
    </v-row>
      <v-row justify="center">
    <v-col align="center">
      <p class="info--text"> We contact you for an interview and obtain copies of your paperwork and meet your equipment. </p>
    </v-col>
    </v-row>
    </v-col>
    <v-col align="center">
    <v-chip large color="info main--text" class="px-6"> <span class="steps"> 3 </span> </v-chip>
    <br/> <br/>
    <v-divider class="line-divider"></v-divider><v-divider class="line-divider"></v-divider>
    <br/>
    <v-row justify="center">
      <h2 class="primary--text"> Get approved </h2>
    </v-row>
    <v-row justify="center">
      <v-img 
      src="@/assets/Approved.svg" 
      alt="Imange1"  
      max-height="170"
      max-width="170"
      class="pt-10 mt-4"
      contain
      />
    </v-row>
    <v-row justify="center">
    <v-col align="center">
      <p class="info--text"> Pass our tests. Receive and schedule bookings from Waste Dash that suite you. </p>
    </v-col>
    </v-row>
    </v-col> 
    </v-row>
    <v-row id="step" justify="center">
    <v-col md="4" align="center">
    <v-chip large color="info main--text" class="px-6"> <span class="steps"> 4 </span> </v-chip>
    <br/> <br/>
    <v-divider class="line-divider"></v-divider> <v-divider class="line-divider"></v-divider>
    <br/>
    <v-row justify="center">
      <h2 class="primary--text"> Show us you can </h2>
    </v-row>
    <v-row justify="center">
      <v-img 
      src="@/assets/Show you can.svg" 
      alt="Imange1"  
      max-height="170"
      max-width="170"
      contain
      />
    </v-row>
    <v-row justify="center">
    <v-col align="center">
      <p class="info--text pl-4"> Driver's licence. Valid PDP. Truck road worthy. Waste management accreditation. Keep all proof of waste disposal.</p>
    </v-col>
    </v-row>
    </v-col>
    <v-col md="4" align="center">
    <v-chip large color="info main--text" class="px-6"> <span class="steps"> 5 </span> </v-chip>
    <br/> <br/>
    <v-divider class="line-divider"></v-divider><v-divider class="line-divider"></v-divider>
    <br/>
    <v-row justify="center">
      <h2 class="primary--text"> Get paid </h2>
    </v-row>
    <v-row justify="center">
      <v-img 
      src="@/assets/Get paid.svg" 
      alt="Imange1"  
      max-height="170"
      max-width="170"
      contain
      />
    </v-row>
      <v-row justify="center">
    <v-col align="center">
      <p class="info--text"> Service our clients and get paid, We pay you bi-weekly: every second Thursday. </p>
    </v-col>
    </v-row>
    </v-col>
    </v-row>
  <v-container>
    <v-row justify="center">
      <v-col align="center">
        <v-row justify="center">
          <v-col align="center" class="primary--text">
            <h2> What our Service Providers say </h2>
          </v-col>
        </v-row>
        <v-row justify="center" align="center">
          <v-col>
            <v-card
              outlined
              rounded="xl"
              color="main--text"
              class="info"
              width="300"
              height="480"
              id="card"
              elevation="0"
            >
              <v-img class="mt-4" height="170" width="170" src="@/assets/Kewin.png"  alt="Kewin"/>
              <v-row
                align="center"
                justify="center"
                class="mt-4"
              >
                <v-col align="center">
                  <h2> Kewin Pietersen <br> Delft </h2>
                </v-col>
              </v-row>
              <div style="display: inline-flex;" class="stars mt-5 pb-5">
                <v-img width="18" height="18" src="@/assets/star.svg" alt="5-stars"/>
                <v-img width="18" height="18" src="@/assets/star.svg" alt="5-stars"/>
                <v-img width="18" height="18" src="@/assets/star.svg" alt="5-stars"/>
                <v-img width="18" height="18" src="@/assets/star.svg" alt="5-stars"/>
                <v-img width="18" height="18" src="@/assets/star.svg" alt="5-stars"/>
              </div> 
              <v-row
                align="center"
                justify="center"
              >
                <v-col align="center">
                  <p class="par"> "Environmental & Life Changing" </p>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
          <v-col>
            <v-card
              outlined
              rounded="xl"
              color="main--text"
              class="info"
              width="300"
              height="480"
              id="card"
              elevation="0"
            >
              <v-img style="border-radius: 80px;" class="mt-4" height="170" width="170" src="@/assets/Alrick.jpg" alt="Alrick"/>
              <v-row
                align="center"
                justify="center"
                class="mt-4"
              >
                <v-col align="center">
                  <h2> Alrick Filander <br>Paarl </h2>
                </v-col>
              </v-row>
              <div style="display: inline-flex;" class="stars mt-5 pb-5">
                <v-img width="18" height="18" src="@/assets/star.svg" alt="5-stars"/>
                <v-img width="18" height="18" src="@/assets/star.svg" alt="5-stars"/>
                <v-img width="18" height="18" src="@/assets/star.svg" alt="5-stars"/>
                <v-img width="18" height="18" src="@/assets/star.svg" alt="5-stars"/>
                <v-img width="18" height="18" src="@/assets/star.svg" alt="5-stars"/>
              </div> 
              <v-row
                align="center"
                justify="center"
                class="pb-4"
              >
                <v-col align="center">
                  <p class="par"> "Waste Dash is the way forward to lighting your load - book now." </p>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
          <v-col>
            <v-card
              outlined
              rounded="xl"
              color="main--text"
              class="info"
              width="300"
              height="480"
              id="card"
              elevation="0"
            >
            <v-img style="border-radius: 80px;" class="mt-4" height="170" width="170" src="@/assets/Christie.png" alt="Christie"/>
              <v-row
                align="center"
                justify="center"
                class="mt-4"
              >
                <v-col align="center">
                  <h2> Christie Hendricks <br> Paarl </h2>
                </v-col>
              </v-row>
              <div style="display: inline-flex;" class="stars mt-5 pb-5">
                <v-img width="18" height="18" src="@/assets/star.svg" alt="5-stars"/>
                <v-img width="18" height="18" src="@/assets/star.svg" alt="5-stars"/>
                <v-img width="18" height="18" src="@/assets/star.svg" alt="5-stars"/>
                <v-img width="18" height="18" src="@/assets/star.svg" alt="5-stars"/>
                <v-img width="18" height="18" src="@/assets/star.svg" alt="5-stars"/>
              </div> 
              <v-row
                align="center"
                justify="center"
              >
                <v-col align="center">
                  <p class="par"> "Champion of Champions" </p>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
  <br/>
  <v-divider> </v-divider><v-divider> </v-divider>
  <br/>

  <v-row justify="center">
    <v-col align="start" class="info--text">
      <h2 class="primary--text"> Tips </h2>
      <br/>
      <ul>
        <li> Ensure that we have all your correct bank details. </li> 
        <li> Only dump legally </li>
        <li> Have an android phone and at least 1 Gig of data per month </li>
        <li> Keep all proof of payments </li>
        <li> Ensure that you have valid legal paperwork for all your operations </li>
      </ul>
      <br/>
      <v-btn 
        color="primary" 
        rounded 
        block
        class="px-16"
        height="50"
        depressed
        href='https://app.wrappwaste.com/driver-singup'
        >
          <h3> Sign Up </h3>
          <v-icon medium class="ml-5"> mdi-arrow-right </v-icon>
        </v-btn>
        <br/>
        <p class="primary--text text-center"> Trusted by over 800 businesses </p>
    </v-col>
  </v-row>
</v-container>
</template>
<script>
export default {
    name: "HowToBecomeDriver",
    data(){
        return{
            model: null, 
        }
    },
    mounted(){
    scrollTo(0, 0);
  }
}
</script>
<style scoped>
#main{
  font-family: Avenir3;
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
}
.headers1{
  font-family: Avenir1;
  font-style: normal;
  font-weight: 750;
  font-size: 48px;
  line-height: 64px;
}
.pText{
  border-radius: 26px;
  position: relative;
  top: -0.5cm;
  background-color: white;
  opacity: 90%;
  
}
@media only screen and (max-width: 580px){
    #step{
    display: block;
  }
  .line-divider{
    display: none;
  }
  #rows{
    display: block;
    position: relative;
    top: -1cm;
  }
  .br{
    display: none;
  }
  p{
    text-align: justify;
    margin-left: 0.5cm;
    margin-right: 0.5cm;
  }
  .par{
    text-align: center;
  }
}
</style>